import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  Grid,
  Header,
  Segment,
} from 'semantic-ui-react';

import SizeSuffix from './SizeSuffix';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import { translateModels } from '../utils/translation';
import { layoutAreaValue, layoutLandAreaValue } from '../utils/unitLayout';

class UnitLayoutItem extends Component {
  static propTypes = {
    name: PropTypes.string,
    size: PropTypes.number,
    landArea: PropTypes.number,
    // CPI-1208: Vietnam's two areas; the list spreads the whole layout record onto this component.
    nfa: PropTypes.number,
    nsa: PropTypes.number,
    summary: PropTypes.shape({
      newUnits: PropTypes.number,
      totalUnits: PropTypes.number,
      delistUnits: PropTypes.number,
    }),
    project: PropTypes.shape({
      sizeSuffix: PropTypes.string,
    }),
    isMobile: PropTypes.bool,
    onClick: PropTypes.func,
    buttonNode: PropTypes.func,
    loading: PropTypes.bool,
    to: PropTypes.string,
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  shouldComponentUpdate(nextProps) {
    if (
      (this.props.name !== nextProps.name) ||
      (this.props.size !== nextProps.size) ||
      (this.props.landArea !== nextProps.landArea) ||
      (this.props.nfa !== nextProps.nfa) ||
      (this.props.nsa !== nextProps.nsa) ||
      (JSON.stringify(this.props.summary) !== JSON.stringify(nextProps.summary)) ||
      ((this.props.project || nextProps.project) &&
      (this.props.project.sizeSuffix !== nextProps.project.sizeSuffix)) ||
      (this.props.isMobile !== nextProps.isMobile) ||
      (this.props.buttonNode && this.props.loading !== nextProps.loading)
    ) {
      return true;
    }
    return false;
  }
  statusColor = (available, total) => {
    const percentage = Math.round((available / total) * 100);
    switch (true) {
      case (percentage >= 75):
        return null;
      case (percentage >= 50):
        return 'yellow';
      case (percentage >= 25):
        return 'orange';
      default:
        return 'red';
    }
  }
  handleOnClick = (e) => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }
  checkAs() {
    if (this.props.to) {
      return Link;
    }
    if (this.props.onClick) {
      return 'a';
    }
    return null;
  }
  hasAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  render() {
    const { t } = this.props;
    const countryCode = this.props.auth && this.props.auth.company && typeof this.props.auth.company.countryCode === 'string'
      ? this.props.auth.company.countryCode.toUpperCase()
      : '';
    const isVietnam = countryCode === 'VN';
    return (
      <Segment>
        <Grid columns="equal" verticalAlign="middle" doubling stackable>
          <Grid.Row textAlign="center">
            <Grid.Column>
              <Grid verticalAlign="middle" columns="equal">
                <Grid.Row only="mobile">
                  <Grid.Column textAlign="center">
                    <Header
                      as={this.checkAs()}
                      content={this.props.name}
                      onClick={this.handleOnClick}
                      to={this.props.to}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row
                  style={this.props.isMobile ? {
                    paddingLeft: '1em',
                    paddingRight: '1em',
                  } : null}
                >
                  <Grid.Column textAlign="left" className="mobile-hide">
                    <Header
                      as={this.checkAs()}
                      content={this.props.name}
                      onClick={this.handleOnClick}
                      to={this.props.to}
                    />
                  </Grid.Column>
                  {/* CPI-1208: a Vietnamese layout is measured in NSA and NFA; every other
                      company keeps Build Up Area and Land Area, in the same two columns. Which
                      pair is read is utils/unitLayout's decision, shared with the form, the
                      detail header and Compare. */}
                  <Grid.Column>
                    <Header
                      size="small"
                      content={isVietnam ? translateModels(t, 'nsa', 'projectUnitLayout') : translateModels(t, 'size', 'projectUnitLayout')}
                      subheader={
                        <SizeSuffix
                          className="sub header"
                          size={layoutAreaValue(isVietnam, this.props)}
                          suffix={this.props.project.sizeSuffix}
                          isVietnam={isVietnam}
                        />
                      }
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Header
                      size="small"
                      content={isVietnam ? translateModels(t, 'nfa', 'projectUnitLayout') : translateModels(t, 'landArea', 'projectUnitLayout')}
                      subheader={
                        <SizeSuffix
                          className="sub header"
                          size={layoutLandAreaValue(isVietnam, this.props)}
                          suffix={this.props.project.sizeSuffix}
                          isVietnam={isVietnam}
                        />
                      }
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Header size="small">
                      {t('Units')}
                      <Header.Subheader>
                        {this.props.summary ? this.props.summary.newUnits : '-'}/
                        {this.props.summary ? this.props.summary.totalUnits : '-'}
                        {
                          this.hasAccess() &&
                          this.props.summary && this.props.summary.delistUnits ?
                            <br /> : null
                        }
                        {
                          this.hasAccess() &&
                          this.props.summary && this.props.summary.delistUnits ?
                            <small>{t('Delist', { ns: TRANSLATION_FILES.constants })}: {this.props.summary.delistUnits}</small>
                          : null
                        }
                      </Header.Subheader>
                    </Header>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column width={7}>
              {
                this.props.buttonNode ?
                this.props.buttonNode({
                  loading: this.props.loading,
                }) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.projectUnitLayout,
])(connect(UnitLayoutItem.mapStateToProps)(UnitLayoutItem));



// WEBPACK FOOTER //
// ./src/components/UnitLayoutItem.jsx